import { ref } from "vue";
import { ApiError } from "./commonQueries";

export function useQuery<R, T>(requestDelegate: (r: R) => Promise<T>) {

    const pending = ref(false);

    const error = ref<ApiError | null>(null);

    const successCallbacks = ref<((req: R, d: T) => void)[]>([]);

    const errorCallbacks = ref<((e: ApiError) => void)[]>([]);

    const data = ref<T>();

    const tried = ref(false);

    const query = async (req: R) => {

        if (pending.value) {
            return;
        }

        try {
            pending.value = true;

            const out = await requestDelegate(req);
            data.value = out;
            error.value = null;

            for (const callback of successCallbacks.value) {
                try {
                    callback(req, out);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
        catch (e) {
            console.error("query fail: " + e);

            const err = e as ApiError;
            if ("error" in err && "error_description" in err) {
                error.value = err;
            }
            else {
                error.value = {
                    error: "Ошибка при выполнении запроса",
                    error_description: String(e)
                };
            }

            for (const callback of errorCallbacks.value) {
                callback(error.value);
            }
        }
        finally {
            pending.value = false;
            tried.value = true;
        }
    }

    const successEvent = {
        on(f: (req: R, d: T) => void) {
            successCallbacks.value.push(f);
        }
    };

    const errorEvent = {
        on(f: (e: ApiError) => void) {
            errorCallbacks.value.push(f);
        }
    }

    return {
        query,
        data,
        error,
        pending,
        onOk: successEvent,
        onError: errorEvent,
        tried: tried
    };
}